export default "__VITE_ASSET__Bf3qbsn5__"